import './mailto.css';

const Mailto = ({ mailto, label }) => {
    return (
       <a className="mailto-link" rel="noreferrer" target="_blank" href={mailto}>{label}</a>
    );
};

export default Mailto;